import { useInfiniteQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";
import { ScanDetails } from "types/scan";

const PAGE_SIZE=24;

export const useGetProjectScansQuery = (
  projectId: string,
  workspace?: string
) => {
  const { authApi } = useAuth();

  const result = useInfiniteQuery({
    queryKey: workspace
      ? ["scans", projectId, workspace]
      : ["scans", projectId],
    queryFn: async ({ pageParam }) => {
      const path = workspace
        ? `/project/scans/${projectId}?page=${pageParam}&perPage=${PAGE_SIZE}&workspace=${workspace}`
        : `/project/scans/${projectId}?page=${pageParam}&perPage=${PAGE_SIZE}`;

      const { data } = await authApi.get<PaginatedResponse<ScanDetails>>(path);
      return data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage: PaginatedResponse<ScanDetails>) => {
      const totalNumPages = Math.ceil(lastPage.total / PAGE_SIZE);
      const hasMore = lastPage.page < totalNumPages
      return hasMore ? (lastPage.page + 1) : undefined
    },
  });

  return result;
};
